import React, { useState, useEffect } from "react";
import { FaPaypal, FaMoneyBillWave, FaCheckCircle } from "react-icons/fa";
import { SiPaytm } from "react-icons/si";
import { FaGooglePay } from "react-icons/fa6";
import { SiPhonepe } from "react-icons/si";
import PaymentModal from '../Modal/PaymentModal';
import { useNavigate } from "react-router-dom";

export default function PaymentOptionsMobile() {
  const [hideBuyNow, setHideBuyNow] = useState(false); // 👈 New

  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showSheet, setShowSheet] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const navigate = useNavigate();

  const loadFacebookSDK = () => {
    if (window.FB) return;
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: "1671165750227956",
        cookie: true,
        xfbml: true,
        version: "v18.0",
      });
    };
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  };

  useEffect(() => {
    loadFacebookSDK();
  }, []);

  const handleFacebookLogin = () => {
    window.FB.login(
      function (response) {
        if (response.authResponse) {
          const { accessToken, userID } = response.authResponse;
          fetch("http://localhost:7000/api/auth/facebook-login", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              accessToken,
              userID,
            }),
          })
            .then(async (response) => {
              if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Facebook login failed");
              }
              return response.json();
            })
            .then((data) => {
              localStorage.setItem("fbUser", JSON.stringify(data.user));
              setShowModal1(false);
              setShowSuccessModal(true);
            })
            .catch((err) => {
              console.error("Login Error", err.message);
            });

        } else {
          console.log("User cancelled login or did not fully authorize.");
        }
      },
      { scope: "public_profile,email" }
    );
  };

  const handleBuyNow = () => setShowModal1(true);
  const handleCloseAll = () => {
    setShowModal1(false);
    setShowModal2(false);
    setShowSheet(false);
  };
  const handleCloseSuccess = () => {
    setShowSuccessModal(false);
    navigate("/");
  };
  const openManualDetailsModal = () => {
    setShowModal1(false);
    setTimeout(() => setShowModal2(true), 200);
  };
  const handleAddCard = () => {
    setShowSheet(false);
    setShowSuccessModal(true);
  };

  return (
    <div style={{ padding: "0 5px" }}>
      {/* Top Section */}
      <div className="d-block d-md-none p-3 bg-white">
        <div
          className="d-flex justify-content-between"
          style={{ marginBottom: "3rem" }}
        >
          <div className="w-50 pe-2">
            <div className="bg-warning bg-opacity-10 rounded p-3 text-center h-100">
              <FaPaypal size={24} className="text-primary mb-1" />
              <div className="fw-bold text-dark mb-1">$ 36.98</div>
              <div className="text-muted small">Paypal</div>
            </div>
          </div>
          <div className="w-50 ps-2">
            <div className="bg-secondary bg-opacity-10 rounded p-3 text-center h-100">
              <FaMoneyBillWave size={24} className="text-success mb-1" />
              <div className="fw-bold text-dark mb-1">$ 36.98</div>
              <div className="text-muted small">Cash</div>
            </div>
          </div>
        </div>
        <div className="buy-now-fixed d-block d-md-none">
          <button
            className="btn w-100 text-white fw-semibold py-2 "
            style={{ backgroundColor: "#000000" }}
            onClick={handleBuyNow}
          >
            Buy Now ₹ 536.98
          </button>
        </div>
      </div>

      {/* Option Modal */}
      {showModal1 && (
        <>
          <div
            className="modal-backdrop-custom"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1040,
            }}
            onClick={() => setShowModal1(false)}
          />
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 1050,
            }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body">
                  <p>Select how you'd like to continue:</p>
                  <button
                    className="btn btn-outline-dark w-100 mb-2"
                    onClick={openManualDetailsModal}
                  >
                    Enter Details Manually
                  </button>
                  <button
                    className="btn btn-outline-dark w-100"
                    onClick={handleFacebookLogin}
                    id=""
                  >
                    Continue with Facebook
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Customer Details Modal */}
      {showModal2 && (
        <>
          <div
            className="modal-backdrop-custom"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1040,
            }}
          />
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 1050,
            }}
            onClick={() => setShowModal2(false)}
          >
            <div
              className="modal-dialog modal-dialog-centered"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-content position-relative">
                <button
                  type="button"
                  className="btn-close position-absolute"
                  aria-label="Close"
                  onClick={() => setShowModal2(false)}
                  style={{ top: "10px", right: "10px", zIndex: 9999 }}
                ></button>
                <div className="modal-body pt-4">
                  <h5 className="fw-bold mb-3 text-center">Customer Details</h5>
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      setShowModal2(false);
                      setHideBuyNow(true);
                      setTimeout(() => setShowSheet(true), 300);
                    }}
                  >
                    <div className="mb-2">
                      <label className="form-label">
                        Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        required
                        className="form-control"
                        placeholder="Enter your name"
                      />
                    </div>
                    <div className="mb-2">
                      <label className="form-label">
                        Phone Number<span className="text-danger">*</span>
                      </label>
                      <input
                        type="tel"
                        required
                        className="form-control"
                        placeholder="Enter your phone number"
                      />
                    </div>
                    <div className="mb-2">
                      <label className="form-label">Age</label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter your age"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Email ID</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter your email (optional)"
                      />
                    </div>
                    <button type="submit" className="btn btn-dark w-100">
                      Submit
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {showSheet && (
        <>
          {/* Background Overlay */}
          <div
            className="modal-backdrop"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 1000,
            }}
            onClick={() => setShowSheet(false)}
          />

          {/* Bottom Sheet */}
          <div
            className="bottom-sheet shadow-lg animate-slide-up"
            style={{
              position: "fixed",
              bottom: 0,
              left: 0,
              width: "100%",
              backgroundColor: "white",
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "20px",
              zIndex: 1100,
              paddingTop: "10px",
            }}
          >
            <button
              type="button"
              className="btn-close position-absolute"
              aria-label="Close"
              onClick={() => setShowSheet(false)} // ✅ Corrected
              style={{ top: "10px", right: "10px", zIndex: 9999 }}
            ></button>

            <div
              className="drag-indicator mx-auto my-2"
              style={{
                width: "40px",
                height: "4px",
                backgroundColor: "#ccc",
                borderRadius: "2px",
              }}
            />
            <h6 className="text-center fw-semibold mb-3">
              Choose your UPI App
            </h6>

            <div className="px-3">
              {/* PhonePe */}
              <button
                className="btn w-100 d-flex align-items-center mb-2 shadow-sm"
                style={{
                  borderRadius: "10px",
                  border: "1px solid #eee",
                  backgroundColor: "#f6f6f6",
                }}
                onClick={() => {
                  setShowSuccessModal(true);
                  setShowSheet(false);
                }}
              >
                <div
                  style={{ width: "24px", height: "24px", marginRight: "10px" }}
                >
                  {" "}
                  <SiPhonepe />
                </div>

                <div>
                  <div className="fw-bold text-start">PhonePe</div>
                  <div className="text-muted small text-start">
                    Pay using PhonePe UPI
                  </div>
                </div>
              </button>

              <button
                className="btn w-100 d-flex align-items-center mb-2 shadow-sm"
                style={{
                  borderRadius: "10px",
                  border: "1px solid #eee",
                  backgroundColor: "#f6f6f6",
                }}
                onClick={() => {
                  setShowSuccessModal(true);
                  setShowSheet(false);
                }}
              >
                <div
                  style={{ width: "24px", height: "24px", marginRight: "10px" }}
                >
                  {" "}
                  <FaGooglePay />
                </div>
                <div>
                  <div className="fw-bold text-start">Google Pay</div>
                  <div className="text-muted small text-start">
                    Pay using GPay UPI
                  </div>
                </div>
              </button>

              {/* Paytm */}
              <button
                className="btn w-100 d-flex align-items-center mb-2 shadow-sm"
                style={{
                  borderRadius: "10px",
                  border: "1px solid #eee",
                  backgroundColor: "#f6f6f6",
                }}
                onClick={() => {
                  setShowSuccessModal(true);
                  setShowSheet(false);
                }}
              >
                <div
                  style={{ width: "24px", height: "24px", marginRight: "10px" }}
                >
                  <SiPaytm />
                </div>

                <div>
                  <div className="fw-bold text-start">Paytm</div>
                  <div className="text-muted small text-start">
                    Pay using Paytm UPI
                  </div>
                </div>
              </button>
            </div>
          </div>
        </>
      )}

      {/* Success Modal */}
      <PaymentModal />
      {/* <Modal
        show={showSuccessModal}
        onHide={handleCloseSuccess}
        centered
        backdrop="static"
      >
        <Modal.Body className="text-center p-4">
          <FaCheckCircle size={40} color="green" className="mb-3" />
          <h5 className="fw-bold">You ordered successfully</h5>
          <p className="text-muted mb-3" style={{ fontSize: "14px" }}>
            Your order is confirmed and will be delivered within 20 minutes.
          </p>
          <button
            variant="link"
            onClick={handleCloseSuccess}
            className="text-dark fw-bold text-decoration-none"
          >
            KEEP BROWSING
          </button>
        </Modal.Body>
      </Modal> */}
    </div>
  );
}
